export default __webpack_public_path__ + "d781be00819877b89f412b40e4e13c63.png";